import { Link } from 'react-router-dom';
import { Button } from '@/components/common';
import { RequirePermission } from '@/components/auth';

export interface NewOperationButtonProps {
  /** Preselects the client on the form, for the entry points that know one. */
  clientId?: number | string;
  size?: 'sm' | 'md';
}

/**
 * The way into the New Operation screen (#271).
 *
 * Sits on Monitoring, on Incoming and on a client's History tab, which is
 * why it is a component rather than three copies of the same link.
 */
export function NewOperationButton({ clientId, size = 'md' }: NewOperationButtonProps) {
  const to = clientId ? `/operations/new?clientId=${clientId}` : '/operations/new';

  return (
    <RequirePermission any={['MANAGE_INCOMING']}>
      <Button asChild variant="default" size={size} data-testid="new-operation-btn">
        <Link to={to}>New Operation</Link>
      </Button>
    </RequirePermission>
  );
}
